class APIS {
	apis() {
		return {
			templateConsumption: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/consumption'
			},
			// ---- Region Rates ----
			// List all billing region rates (payload: {})
			ratesList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/billing/rates/list'
			},
			// Create / update a billing region rate (upsert).
			// payload: { region, category, rate_usd, selling_rate_usd }
			ratesUpsert: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/billing/rates'
			},
			// ---- Client Rates ----
			// List client rates (payload: { client_id } or {} for all clients)
			clientRatesList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/billing/client-rates/list'
			},
			// Create / update a client rate (upsert).
			// payload: { client_id, category, rate, currency }
			clientRatesUpsert: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/billing/client-rates'
			},
			// Update a client's billing config.
			// payload: { client_id, billing_currency, charge_others }
			clientConfig: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/billing/client-config'
			},
			// ---- Exchange Rates ----
			// List exchange rates (payload: { effective_year })
			exchangeRatesList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/billing/exchange-rates/list'
			},
			// Create / update an exchange rate (upsert).
			// payload: { rate, effective_month, effective_year, reference_source }
			exchangeRatesUpsert: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/billing/exchange-rates'
			},
			// ---- Additional Charges ----
			// Create an additional charge.
			// payload: { client_id, description, amount_pkr, billing_month, billing_year }
			additionalCharges: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/billing/additional-charges'
			},
			// List additional charges (payload: { billing_month, billing_year })
			additionalChargesList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/billing/additional-charges/list'
			},
			// Approve an additional charge. Call with
			// { key: ':id', value: <id>, params: { status: 'approved' } }
			additionalChargesApprove: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/billing/additional-charges/:id/approve'
			},
			// ---- Reports ----
			// Billing report list (payload: { month, year })
			reportList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/billing/report'
			},
			// Trigger report generation (payload: { month, year })
			reportGenerate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/billing/report/generate'
			},
			// Trigger report generation + email (payload: { month, year, email })
			reportEmail: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/billing/report/email'
			},
			// Update the status-change count for a client's billing month.
			// payload: { client_id, billing_month, billing_year, status_changes }
			statusChanges: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/billing/status-changes'
			},
		};
	}
}

export default new APIS();
